(function () {
    "use strict";

    angular.module('iMatApp')
        .filter('salesPrice', salesPriceFilter);

    salesPriceFilter.$inject = [];

    function salesPriceFilter() {
        return function (salesPrice, priceName) {
            if (!salesPrice || !salesPrice.isReady()) {
                return '--';
            }

            if (salesPrice.issue) {
                return 'N/A';
            }

            var price = salesPrice[priceName];
            if (price) {
                return price.formatted;
            }

            return '--';
        };
    }
})();